import { Injectable } from '@angular/core';
import {
  BookingProductType,
  isBookingProductTypePackage,
  isBookingProductTypeTariff
} from '@products/models/booking.model';
import { TariffUuids } from '@products/models/tariff.model';
import { getUUID } from '@shared/app-utils';

@Injectable({
  providedIn: 'root'
})
export class BookingHolderService {
  setTariffUuids(tariffCount: number, isTariffClassificationParking: boolean): TariffUuids {
    return !isTariffClassificationParking && tariffCount > 0 ? Array(tariffCount).fill(null).map(getUUID) : [];
  }

  getSetProductBookingsTariffUuids(bookingProductTypes: BookingProductType[]): TariffUuids {
    const tariffUuids: TariffUuids = [];

    bookingProductTypes.forEach((bookingProductType) => {
      if (isBookingProductTypeTariff(bookingProductType)) {
        bookingProductType.tariffs.forEach((bookingTariff) => {
          tariffUuids.push(...bookingTariff.tariffUuids);
        });
      } else if (isBookingProductTypePackage(bookingProductType)) {
        bookingProductType.productTypes.forEach((bookingPackageProductType) => {
          if (isBookingProductTypeTariff(bookingPackageProductType)) {
            bookingPackageProductType.tariffs.forEach((bookingPackageTariff) => {
              tariffUuids.push(...bookingPackageTariff.tariffUuids);
            });
          }
        });
      }
    });

    return tariffUuids;
  }
}
